export default __webpack_public_path__ + "static/media/referral__icon-1.ed16fe3b.svg";